module.exports = __webpack_public_path__ + "media/static/icons/icon-info--circle-d4d0b4f4324a24a3892203661abf206e.svg";